<div class="checkbox-filter">
  <div class="checkbox-filter__option" *ngFor="let option of options; trackBy: identify">
    <brt-checkbox (state-changed)="toggleOption(option.id)" [data]="{id: option.id, label: option.title, selected: option.selected, disabled: false}"></brt-checkbox>
  </div>
</div>
